import api from "../../index";

export const GetAllPaymentGatwaysApi = (params) => api.get(`PaymentGateway/PaymentGatways?${params}`);
export const UpdatePaymentGatwayStatusApi = (PaymentGatewayId,params) => api.patch(`PaymentGateway/UpdatePaymentGatewayStatus/${PaymentGatewayId}?${params}`);
export const UpdategetwayApi = (id, data, headers) => api.put(`PaymentGateway/Update-PaymentGetwayById/${id}`, data, headers);